import { Field } from "formik";
import React, { type FC } from "react";

type HiddenFieldProps = Omit<React.ComponentPropsWithoutRef<"input">, "type">;

const HiddenField: FC<HiddenFieldProps> = (props) => (
  <Field type="hidden" {...props} />
);

export { HiddenField };
